// extracted by mini-css-extract-plugin
export default {"title":"Browse_title__-Vzeq","card_container":"Browse_card_container__PHcMn","pagination_box":"Browse_pagination_box__uo8b1","page_container":"Browse_page_container__VTI-a"};